/* =========================================================================
   CHARMANTE — Jauge de progression vers la LIVRAISON GRATUITE
   Composant unique réutilisé partout (panier + pop-up flottant sur toutes
   les pages). Lit le total depuis l'état panier existant
   (window.Charmante.cart) → reste synchronisé en temps réel.

   API : window.Charmante.freeship  ·  window.Charmante.freeship.THRESHOLD
   Textes traduits via window.t / window.CharmanteI18n (pont dans theme.liquid).
   ========================================================================= */
(function () {
  'use strict';

  var t = window.t || function (k, fb) { return fb == null ? k : fb; };

  // ===== Constante centralisée (modifiable facilement) =====
  const FREE_SHIPPING_THRESHOLD = 60;   // € — seuil de livraison gratuite

  const C = (window.Charmante = window.Charmante || {});
  const round2 = (n) => Math.round(n * 100) / 100;
  const money = (n) => round2(n).toFixed(2).replace('.', ',') + ' €';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SEEN_KEY = 'charmante_fs_unlocked';     // a déjà célébré (évite de refêter)
  const CLOSED_KEY = 'charmante_fs_closed';      // pop-up fermé (session)

  /* ---------- Calcul (cas limites : panier vide = 0 %, ≥ seuil = 100 %) --- */
  function info(total) {
    total = Math.max(0, +total || 0);
    const pct = Math.max(0, Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100)));
    const reached = total >= FREE_SHIPPING_THRESHOLD;
    const remaining = Math.max(0, round2(FREE_SHIPPING_THRESHOLD - total));
    const message = reached
      ? t('fs_unlocked')
      : t('fs_remaining').replace('{amount}', money(remaining));
    return { total, pct, reached, remaining, message, threshold: FREE_SHIPPING_THRESHOLD };
  }

  /* ---------- Jauge dans le panier (rendue par cart.js) ------------------ */
  function gaugeHTML(total) {
    const i = info(total);
    return `<div class="fsg${i.reached ? ' is-done' : ''}">
      <p class="fsg__msg">${i.reached ? '' : '🚚 '}${i.message}</p>
      <div class="fsg__track" role="progressbar" aria-valuenow="${i.pct}" aria-valuemin="0" aria-valuemax="100" aria-label="${i.message.replace(/"/g, '')}">
        <div class="fsg__fill" style="width:${i.pct}%"></div>
      </div>
      <p class="fsg__pct">${i.pct}%</p>
    </div>`;
  }

  C.freeship = { THRESHOLD: FREE_SHIPPING_THRESHOLD, info, gaugeHTML };

  /* ---------- Pop-up flottant (toutes pages) ----------------------------- */
  const onCartPage = () => !!document.getElementById('cartRoot') || document.body.classList.contains('template-cart');
  let popEl = null, prevCount = -1;
  const closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function buildPopup() {
    popEl = document.createElement('aside');
    popEl.className = 'fspop';
    popEl.id = 'fspop';
    popEl.setAttribute('aria-live', 'polite');
    popEl.setAttribute('aria-label', t('fs_progress'));
    popEl.hidden = true;
    popEl.innerHTML = `<button class="fspop__close" type="button" aria-label="${t('close')}">${closeIcon}</button>
      <p class="fspop__msg"></p>
      <div class="fspop__track" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="fspop__fill"></div></div>
      <p class="fspop__sub"></p>`;
    document.body.appendChild(popEl);
    popEl.querySelector('.fspop__close').addEventListener('click', () => {
      popEl.hidden = true;
      try { sessionStorage.setItem(CLOSED_KEY, '1'); } catch (e) {}
    });
  }

  function fillPopup(total) {
    const i = info(total);
    popEl.classList.toggle('is-done', i.reached);
    popEl.querySelector('.fspop__msg').innerHTML = i.reached
      ? t('fs_unlocked')
      : t('fs_remaining_html').replace('{amount}', money(i.remaining));
    popEl.querySelector('.fspop__sub').textContent = i.reached ? t('fs_enjoy') : t('fs_progress_pct').replace('{pct}', i.pct);
    const fill = popEl.querySelector('.fspop__fill');
    fill.style.width = i.pct + '%';
    const track = popEl.querySelector('.fspop__track');
    track.setAttribute('aria-valuenow', i.pct);
    track.setAttribute('aria-label', i.message.replace(/"/g, ''));
  }

  function refreshPopup(justAdded) {
    if (!popEl) return;
    const total = C.cart ? C.cart.subtotal() : 0;
    const count = C.cart ? C.cart.count() : 0;
    fillPopup(total);
    if (onCartPage() || count === 0) { popEl.hidden = true; return; }   // masqué sur la page panier (la grande jauge y est) et si panier vide
    if (justAdded) { try { sessionStorage.removeItem(CLOSED_KEY); } catch (e) {} }
    let closed = false; try { closed = sessionStorage.getItem(CLOSED_KEY) === '1'; } catch (e) {}
    popEl.hidden = closed;
    // disparaît tout seul 3 s après son apparition
    if (!popEl.hidden) {
      clearTimeout(popEl._autohide);
      popEl._autohide = setTimeout(function () { popEl.hidden = true; }, 3000);
    }
  }

  /* ---------- Célébration au déblocage de la livraison gratuite ---------- */
  function maybeCelebrate(total) {
    const reached = total >= FREE_SHIPPING_THRESHOLD;
    let seen = false; try { seen = localStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}
    if (reached && !seen) { try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {} celebrate(); }
    else if (!reached && seen) { try { localStorage.setItem(SEEN_KEY, '0'); } catch (e) {} }   // repassé sous le seuil : on pourra refêter
  }
  // Déblocage de la livraison gratuite : petit toast informatif uniquement
  // (confettis + flash retirés — préférence design sobre).
  function celebrate() {
    if (C.showToast) C.showToast(t('fs_unlocked_toast'));
  }

  /* ---------- Cycle de vie ----------------------------------------------- */
  function onCartChange() {
    const total = C.cart ? C.cart.subtotal() : 0;
    const count = C.cart ? C.cart.count() : 0;
    const justAdded = prevCount >= 0 && count > prevCount;
    prevCount = count;
    refreshPopup(justAdded);
    maybeCelebrate(total);
  }
  function init() {
    buildPopup();
    prevCount = C.cart ? C.cart.count() : 0;
    // synchronise l'état « déjà débloqué » sans fêter au chargement
    try { localStorage.setItem(SEEN_KEY, (C.cart && C.cart.subtotal() >= FREE_SHIPPING_THRESHOLD) ? '1' : '0'); } catch (e) {}
    refreshPopup(false);
    document.addEventListener('cart:change', onCartChange);
  }
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
